"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var BrandLandingCountryEditor = /** @class */ (function (_super) {
    __extends(BrandLandingCountryEditor, _super);
    function BrandLandingCountryEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandLandingCountryEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_country_id: _item.app_country_id,
                    app_country_title: _item.app_country_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Страны баннера", "Редактировать страну"]);
                });
            }
        }
        else {
            this.setState({
                app_country_id: 0,
                app_country_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Страны баннера", "Создать страну"]);
            });
        }
        this.doReSetRules();
    };
    BrandLandingCountryEditor.prototype.doReSetRules = function () {
        this.setState({
            app_country_rules: { isError: false },
        });
    };
    BrandLandingCountryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_country_id <= 0) || (this.state.app_country_title.length === 0)) {
            this.setState({ app_country_rules: { isError: true, errorMessage: "Страна не выбрана!" } });
            return false;
        }
        return true;
    };
    BrandLandingCountryEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_country_id: this.state.app_country_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страна баннера изменена!");
            });
        }
    };
    BrandLandingCountryEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_country_id: this.state.app_country_id,
                brand_aff_landing_id: this.props.rootRecord.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страна баннера добавлена!");
            });
        }
    };
    BrandLandingCountryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandLandingCountryEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая cтрана баннера";
        }
        else {
            return "Изменить cтрану баннера";
        }
    };
    BrandLandingCountryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 260 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Страна:", placeholder: "Выберите страну" }, value: { key: this.state.app_country_id, value: this.state.app_country_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_country_id: newVal.key,
                        app_country_title: newVal.value,
                        app_country_rules: { isError: false }
                    });
                }, items: this.props.availCountry, required: true, rules: this.state.app_country_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandLandingCountryEditor;
}(React.Component));
exports.default = BrandLandingCountryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_landings_list/ui/component/country/BrandLandingCountryEditor.tsx
// module id = 2419
// module chunks = 0